/*
    sidebar component should be a component usable for all main views
*/
import React, { useState } from "react";
import { rbac } from "../index";
import t from "../../../helpers/t";
import Popup from "reactjs-popup"; // maybe useful component to display additional info
import NewPricetariffButton from "./NewPricetariffButton";
import { $, Foundation, moment } from "../../../../../vendor";
import { ListItem } from "../../tasks/styled_components/list";
import Select from "react-select";
import DropDown from "./Dropdown";
import Biscuit from "../../../../utils/Biscuit";

const PricetariffSidebar = (props) => {
  /*   let locations = props.locations;
    let tempData = [{'id': 'all', 'name': t('all')}];

    for ( let index=0; index<locations.length; index++ ) {
        tempData.push( locations[index] );
    }
    locations=tempData;

    let contingents = props.contingentsAll;

    tempData = [{'id': 'all', 'name': t('all')}];
    for ( let index=0; index<contingents.length; index++ ) {
        tempData.push( contingents[index] );
    }
    contingents=tempData;

    const [locationFilter, setLocationFilter] = useState("all");

    const [contingentFilter, setContingentFilter] = useState("all");

    const [statusFilter, setStatusFilter] = useState('all');


    const [globalFilter, setGlobalFilter] = useState({});           // set empty object, there are no filters set by default

    const handleChangeTo = value => {

        var globalClone = {};

        // update global filter
        Object.assign(globalClone,globalFilter);        // get current values of global filter (all filter)


        setGlobalFilter(globalClone);
        props.setSelectedFilter(globalClone);           // cloned object must be used because global filter is not yet updated
    };

    const onLocationFilterChange = (val) => {
        setLocationFilter(val.target.value);                  // set status filter
        let clone = {};
        Object.assign(clone,props.filters);              // get current filter settings (all filter)

        if (val.target.value !== 'all') {
            // add status filter to global filter
            clone.location_id = val.target.value;
        } else {
            console.log('inside');
            // remove status filter from global filter
            delete clone['location_id'];
        }
        setGlobalFilter(clone);
        props.setSelectedFilter(clone);                 // cloned object must be used because global filter is not yet updated
    };

    const onContingentFilterChange = (val) => {

        setContingentFilter(val.target.value);                  // set status filter
        let clone = {};
        Object.assign(clone,props.filters);              // get current filter settings (all filter)

        if (val.target.value !== 'all') {
            // add status filter to global filter
            clone.contingent_id = val.target.value;
        } else {
            // remove status filter from global filter
            delete clone['contingent_id'];
        }
        setGlobalFilter(clone);
        props.setSelectedFilter(clone);                 // cloned object must be used because global filter is not yet updated
    };



    const onStatusFilterChange = (val) => {

        setStatusFilter(val);                  // set status filter
        let clone = {};
        Object.assign(clone,props.filters);              // get current filter settings (all filter)

        if (val != 'all') {
            // add status filter to global filter
            clone.status = val;
        } else {
            // remove status filter from global filter
            delete clone['status'];
        }
        setGlobalFilter(clone);
        props.setSelectedFilter(clone);                 // cloned object must be used because global filter is not yet updated
    };

    let _dropdown = null;

    const _initDropdown = (ev) => {

        ev.preventDefault();

        if (_dropdown === null) {
            _dropdown = new Foundation.Dropdown($('#inb-c-sidebar .inb-dropdown'));
        }
        _dropdown.open();

        return false;
    };*/

  return (
    <aside id="inb-c-sidebar" className="resources-sidebar" style={{ float: "left" }}>
      <header className="inb-c-left-bar__title sticky-top">
        <h1 className="inb-page-title">{t("pricetariffs")}</h1>

        {/*<aside className="inb-c-item__actions">
                    <button
                        className="button round inb-toggle-sidebar-dd"
                        type="button"
                        data-toggle="inb-sidebar-dd"
                        onClick={_initDropdown}
                        title={t('quick_actions')}>
                        ...
                    </button>
                    <div
                        className="dropdown-pane inb-dropdown"
                        id="inb-sidebar-dd"
                        //data-dropdown
                        data-position="right"
                        data-alignment="center"
                        data-close-on-click="true">
                        <ul className="inb-dropdown__list">


                <li>
                    <a href="#"
                       rel="noopener noreferrer"
                       id="export-xls-resources">
                        <i className="ico-inb inb-fi-excel"></i>
                        {t(' export_xls_resources', null, ' capital')}
                    </a>
                </li>
            </ul>
        </div>
    </aside>*/}
      </header>
      <div className="sticky-top-filter">
        {/*    <ul id="inb-c-left-bar-flist--resource-status"
                className="inb-vert-list">
                <span className="inb-list-title">
                    {t('status',null,'capital')}
                </span>
                {['all', 'active', 'defect'].map(status => (
                    <ListItem
                        className={status === statusFilter? 'active' : ''}
                        key={status}>

                  <span onClick={() => onStatusFilterChange(status)}>
                    {(status==='active')?t('active',null,'capital'):(status==='defect')?t('defect',null,'capital'):t('all',null,'capital')}
                  </span>

                        {statusFilter !== null && statusFilter !== 'all' && statusFilter === status &&
                        <a
                            href="#"
                            className="unset-filter"
                            onClick={() => onStatusFilterChange('all')}
                            title={t('unselect_filter')}>
                            x
                        </a>
                        }
                    </ListItem>
                ))}
            </ul>
            <ul id="inb-c-left-bar-flist--resource_location"
                className="inb-vert-list">
                <span className="inb-list-title">
                    {t('location',null,'capital')}
                </span>
                <select
                    className="inbooma-select-box__input"
                    name="locations"
                    onChange={(e) => onLocationFilterChange(e)}
                    value={locationFilter}
                    placeholder={t('select_${a}',{a:t('location')})}>
                    {locations.map(location => {
                        return(
                            <>
                                <option key={location.id} value={location.id}>{location.name}</option>
                            </>
                        )
                    })}
                </select>
            </ul>
            <ul id="inb-c-left-bar-flist--resource-contingent"
                className="inb-vert-list">
                <span className="inb-list-title">
                    {t('contingent',null,'capital')}
                </span>
                <select
                    className="inbooma-select-box__input"
                    name="contingents"
                    onChange={(e) => onContingentFilterChange(e)}
                    value={contingentFilter}
                    placeholder={t('select_${a}',{a:t('contingent')})}>
                    {contingents.map(contingent => {
                        return(
                            <>
                                <option key={contingent.id} value={contingent.id}>{contingent.name}</option>
                            </>
                        )
                    })}
                </select>

            </ul>*/}
      </div>
      {rbac.hasPermission("write") && (
        <footer
          className="inb-c-left-bar__footer small-only-float-container"
          data-inb-action-link="write"
        >
          <NewPricetariffButton onClicked={props.addNewPricetariff} />
        </footer>
      )}
    </aside>
  );
};

export default PricetariffSidebar;
